var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgO2CIntegrationProces({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 235.69 235.69",
    style: {
      enableBackground: "new 0 0 235.69 235.69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7A7A7A;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:4.375;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:3.125;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.875;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:1.4452;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:3.1672;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2.5;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:6.7028;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:4.4918;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:4.6253;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#FFFFFF;stroke-width:5.7817;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:4.6253;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:5.7817;stroke-linecap:round;stroke-linejoin:round;}\r\n\t\r\n\t\t.st15{fill:none;stroke:#FFFFFF;stroke-width:5.7817;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:14.4096,14.4096;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "strzaka"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 91.25,
    y1: 220.31,
    x2: 220,
    y2: 220.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.31,
    y: 103.44,
    className: "st4",
    width: 55.62,
    height: 116.88
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.81,
    y: 111.74,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.81,
    y: 111.74,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.81,
    y: 111.74,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.81,
    y: 139.86,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.81,
    y: 139.86,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.81,
    y: 139.86,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.81,
    y: 167.99,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.81,
    y: 167.99,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.81,
    y: 167.99,
    className: "st5",
    width: 10.62,
    height: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.44,
    y: 167.99,
    className: "st6",
    width: 10.62,
    height: 13.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.44,
    y: 167.99,
    className: "st6",
    width: 10.62,
    height: 13.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 167.99,
    className: "st6",
    width: 10.62,
    height: 13.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.44,
    y: 185.49,
    className: "st6",
    width: 10.62,
    height: 13.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.44,
    y: 185.49,
    className: "st6",
    width: 10.62,
    height: 13.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 185.49,
    className: "st6",
    width: 10.62,
    height: 13.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.94,
    y: 159.06,
    className: "st7",
    width: 55.62,
    height: 61.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.5,62.5 87.5,118.75 38.12,118.75 38.12,46.25 71.25,46.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "87.5,62.5 71.25,62.5 71.25,46.25  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M87.5,62.5L71.25,46.25L87.5,62.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "64.38,46.25 64.38,36.25 48.12,20 15,20 15,92.5 38.12,92.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 64.38,
    y1: 92.5,
    x2: 48.12,
    y2: 92.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "64.38,36.25 48.12,36.25 48.12,20  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M64.38,36.25L48.12,20L64.38,36.25z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 48.12,
    y1: 73.75,
    x2: 78.09,
    y2: 73.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 48.12,
    y1: 80,
    x2: 78.09,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 48.12,
    y1: 86.25,
    x2: 78.09,
    y2: 86.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 48.12,
    y1: 92.5,
    x2: 78.09,
    y2: 92.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 48.12,
    y1: 98.75,
    x2: 78.09,
    y2: 98.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.44,46.99c0.51-1.61,1.68-2.34,3.28-2.72c17.61-4.21,33.31-0.29,47.2,11.12 c7.24,5.94,12.71,13.36,17.29,21.47c0.31,0.55,0.62,1.09,1.15,2.03c0.23-0.98,0.4-1.61,0.53-2.25c0.59-2.96,1.16-5.93,1.74-8.9 c0.69-3.47,2.68-4.22,5.38-2.03c0.14,0.57,0.28,1.13,0.42,1.7c-1.19,5.92-2.39,11.85-3.58,17.77c-0.59,2.93-1.56,3.61-4.49,3.07 c-5.55-1.03-11.09-2.07-16.64-3.1c-2.7-0.5-3.8-1.6-3.48-3.41c0.34-1.91,1.77-2.53,4.59-2.01c3.43,0.64,6.85,1.29,10.65,2 c-0.37-0.75-0.58-1.24-0.84-1.7c-5.71-10.28-12.87-19.28-23.18-25.32c-11.29-6.61-23.33-8.3-36.01-4.89 c-1.5,0.4-2.61-0.07-3.59-1.13C89.72,48.13,89.58,47.56,89.44,46.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.05,191.2c-0.95,1.4-2.28,1.76-3.92,1.66c-18.07-1.05-31.98-9.33-41.99-24.26 c-5.22-7.78-8.31-16.46-10.36-25.55c-0.14-0.61-0.28-1.23-0.52-2.27c-0.5,0.87-0.85,1.43-1.15,2c-1.42,2.67-2.82,5.35-4.24,8.01 c-1.66,3.13-3.78,3.27-5.73,0.39c0.03-0.58,0.06-1.16,0.09-1.75c2.85-5.33,5.71-10.65,8.56-15.98c1.41-2.64,2.54-3.01,5.18-1.64 c5.01,2.59,10.03,5.18,15.04,7.77c2.44,1.26,3.18,2.63,2.35,4.27c-0.87,1.73-2.42,1.92-4.97,0.6c-3.1-1.6-6.19-3.21-9.62-4.98 c0.14,0.82,0.2,1.35,0.31,1.87c2.5,11.49,6.76,22.18,14.89,30.93c8.9,9.58,19.94,14.68,33.07,15.07c1.55,0.05,2.48,0.82,3.11,2.12 C89.11,190.03,89.08,190.62,89.05,191.2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO2CIntegrationProces);
export default __webpack_public_path__ + "static/media/O2C_Integration_Proces.e56ef280f90c2204fc3fb44fac54793d.svg";
export { ForwardRef as ReactComponent };